import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IInventoryProductGeneralDetailsResponse,
  IInventoryProductGeneralDetailsResponseData,
} from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useInventoryProductDetailsAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const [productDetails, setProductDetails] = useState<IInventoryProductGeneralDetailsResponseData>(null);
  const execute = useCallback(
    async (productID: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(`${INVENTORY_MODULE?.PRODUCT_UPDATE_API?.baseURL}${productID}/` , {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IInventoryProductGeneralDetailsResponse>) => {
            if (res.data.status === true) {
              setProductDetails(res.data.data);
            } else {
              setProductDetails(null);
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            setProductDetails(null);
            captureError(e)
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute, productDetails, setProductDetails };
};
